var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled, ThemeProvider } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { Text, TextTag, TokenTextAppearance, TokenTextColor } from '../text';
export const getBackgroundColorByAppearance = (props) => {
    const { theme, appearance } = props;
    const tokensColorsObj = Object.assign(Object.assign({}, theme.colors.signal), { new: theme.colors.signal.promo, alert: theme.colors.signal.neutral });
    return tokensColorsObj[appearance];
};
const getColorByAppearance = (props) => {
    const { theme, appearance } = props;
    if (['success', 'alert', 'error', 'bookmark'].includes(appearance)) {
        return theme.colors.content.inverted;
    }
    return theme.colors.content.tertiary;
};
const StyledDisplayTag = styled.div.withConfig({ displayName: "StyledDisplayTag", componentId: "sc-1xqza3j" }) `display:flex;gap:${({ theme }) => theme.size.static100};align-items:center;width:fit-content;height:${({ theme }) => theme.size.static350};background-color:${getBackgroundColorByAppearance};color:${getColorByAppearance};padding:${({ theme }) => theme.size.static150};p{margin-top:${({ theme }) => theme.size.static0};::first-letter{text-transform:uppercase;}}`;
export const DisplayTag = (props) => {
    //className is added to the props to be able to overwrite the StyledDisplayTag className
    const { appearance, id, text, className, icon } = props, rest = __rest(props, ["appearance", "id", "text", "className", "icon"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(ThemeProvider, { theme: "main" },
        React.createElement(StyledDisplayTag, Object.assign({ appearance: appearance, className: className, id: id }, commonProps, rest),
            icon,
            React.createElement(Text, { tag: TextTag.p, appearance: TokenTextAppearance.copy100, color: TokenTextColor.inherit }, text))));
};
DisplayTag.displayName = 'DisplayTag';
